const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "setiembre", "octubre", "noviembre", "diciembre",
];

// "2026-08" -> "Agosto 2026" · "2026-07G" -> "Julio 2026 · Gratificación"
export function fmtPeriodo(periodo) {
  const m = /^(\d{4})-(\d{2})(G?)$/.exec(String(periodo || ""));
  if (!m) return periodo || "-";
  const mes = MESES[Number(m[2]) - 1];
  if (!mes) return periodo;
  const texto = `${mes.charAt(0).toUpperCase()}${mes.slice(1)} ${m[1]}`;
  return m[3] ? `${texto} · Gratificación` : texto;
}

// "2026-02-01 10:30:00.123" -> "01/02/2026 10:30"
export function fmtFecha(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/.exec(String(value || ""));
  if (!m) return value || "-";
  const fecha = `${m[3]}/${m[2]}/${m[1]}`;
  return m[4] ? `${fecha} ${m[4]}:${m[5]}` : fecha;
}

// Minúsculas y sin tildes, para búsquedas tolerantes ("callañaupa" ~ "CALLANAUPA").
export function normalizarTexto(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export function nombreArchivoBoleta(row) {
  return `boleta_${row.persona}_${row.periodo}.pdf`;
}
